import "./app.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import ServicesPage from "./pages/servicespage";
import GalleryPage from "./pages/gallerypage";
import AboutPage from "./pages/aboutpage";
import ContactPage from "./pages/contactpage";
import ThankYouPage from "./pages/thankyoupage";
import BlogPage from "./pages/blogpage";
import AdminLogin from "./pages/adminlogin";
import AdminDashboard from "./pages/admindashboard";
import ProtectedRoute from "./components/protectedroute";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./context/languagecontext";
import { AudienceProvider } from "./context/audiencecontext";
import { AudienceSelector } from "./components/audienceselector";

function App() {
  return (
    <LanguageProvider>
      <AudienceProvider>
        <div className="App">
          <BrowserRouter>
            <AudienceSelector />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/thank-you" element={<ThankYouPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin/dashboard"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </BrowserRouter>
          <Toaster />
        </div>
      </AudienceProvider>
    </LanguageProvider>
  );
}

export default App;
